export default {
  namespaced: true,
  state: {
    enableCamera: false,
    enableMic: false
  },
  getters: {
    enableCamera: state => state.enableCamera,
    enableMic: state => state.enableMic
  },
  mutations: {
    setEnableCamera(state, enableCamera) {
      state.enableCamera = enableCamera
    },
    setEnableMic(state, enableMic) {
      state.enableMic = enableMic
    }
  },
  actions: {
    setEnableCamera(state, enableCamera) {
      state.commit("setEnableCamera", enableCamera)
    },
    setEnableMic(state, enableMic) {
      state.commit("setEnableMic", enableMic)
    }
  }
}
